module.exports = __webpack_public_path__ + "img/cross.be0b7b2d.svg";